/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

import {Component, ElementRef, EventEmitter, Input, Output} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {InputAccessor} from '../input-accessor';
import {UiSelect} from "../ui-select/ui-select";

export interface UiListItem {
    id: any;
    caption: string;
}

@Component({
    selector: 'ui-list-box',
    template: require('./ui-list-box.html'),
    styles: [require('./ui-list-box.less')],
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: UiListBox, multi: true}
    ]
})
export class UiListBox extends InputAccessor {

    @Input() list: UiListItem[] = [];

    get innerValue(): any {
        return this._innerValue;
    }

    set innerValue(value: any) {
        super.updateValue(value);
    }

    constructor(public elementRef: ElementRef) {
        super();
    }

    public prepareValueHook() {}


}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/ui-elements/ui-list-box/ui-list-box.ts